export default {
  methods: {
    $_change(endLabel) {
      this.$emit('change', this.result, this.index)
      this.$emit('input', this.result, this.index)
    }
  }
}
